import React, { Component } from 'react'
import { connect } from 'react-redux'
import { intComma } from 'humanize-plus'
import { Input, Div, Button, Span } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'

import { getSegmentTypesAvailableForFiltering } from '../constants/SegmentTypes'
import { filterSegmentType } from 'modules/segments/actions'

import './style.css'

const mapStateToProps = (state) => ({
  selectedSegments: state.__CRM.segments.selectedSegments,
  filteredSegmentType: state.__CRM.segments.filteredSegmentType,
});

const mapDispatchToProps = (dispatch) => ({
  onFilterSegmentType: (type) => dispatch(filterSegmentType(type)),
});

class SegmentControls extends Component {
  handleSearch = (e) => {
    const { onFilterSegmentType, filteredSegmentType, onSearch } = this.props
    filteredSegmentType !== 'ALL' && onFilterSegmentType('ALL')
    onSearch(e)
  };

  render() {
    const {
      totalSegments,
      onSelectAll,
      onDelete,
      onFilterSegmentType,
      selectedSegments,
      filteredSegmentType,
    } = this.props;

    const allSegmentsDropdownOption = {
      value: 'ALL',
      label: 'All segments',
      title: `All segments (${totalSegments})`,
    };
    const segmentTypeDropdownOptions = getSegmentTypesAvailableForFiltering().map(
      (segmentType) => ({
        value: segmentType.key,
        label: segmentType.displayNameFullPlural,
        title: `${segmentType.displayNameFullPlural} (${totalSegments})`,
      })
    );

    const allDropdownOptions = [
      allSegmentsDropdownOption,
      ...segmentTypeDropdownOptions,
    ];

    const selectValue = allDropdownOptions.filter(({ value }) => value === filteredSegmentType)

    const renderOption = (option) => {
      return <div> {option.label}</div>
    };

    return (
      <Div className='segments-controls'>
        {selectedSegments.length === 0 && (
          <Select
            className="segments-controls--filter-type-select"
            value={selectValue}
            onChange={(value) => {
              onFilterSegmentType(value.value)
            }}
            clearable={false}
            searchable={false}
            labelKey='title'
            options={allDropdownOptions}
            optionRenderer={renderOption}
          />
        )}
        {selectedSegments.length > 0 && (
          <Div className='segments-controls--text-controls'>
            <Div className='segments-controls--text-controls--selected'>
              <Span>{`${intComma(
                selectedSegments.length
              )} segments selected`}</Span>
              <Span className='link' onClick={() => onSelectAll(false)}>
                Clear
              </Span>
            </Div>
            <Div className='segments-controls--text-controls--buttons'>
              <Button type='utility' onClick={() => onDelete()} icon='trash'>
                Delete Segments
              </Button>
            </Div>
          </Div>
        )}
        <Input
          placeholder='Search segment names'
          onChange={this.handleSearch}
          type='search'
        />
      </Div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentControls)
